import { type AccentHue, colorize } from "@repo/fika-design-system/color"
import type { IconName } from "@repo/fika-design-system/icon"
import { For, Show } from "solid-js"
import { Icon } from "../components/icon"
import { pillRecipe, pillsClass } from "./pills.css"

export type Pill = {
  icon?: IconName
  rounded?: boolean
  label: string
  hue: AccentHue
}

type PillsProps = {
  pills: Pill[]
}

export function Pills(props: PillsProps) {
  return (
    <ul class={pillsClass}>
      <For each={props.pills}>
        {pill => (
          <li class={pillRecipe({ hue: pill.hue, rounded: pill.rounded })}>
            <Show when={pill.icon}>
              {icon => (
                <Icon
                  color={colorize(pill.hue, "700")}
                  name={icon()}
                  title={pill.label}
                  size="18"
                />
              )}
            </Show>
            {pill.label}
          </li>
        )}
      </For>
    </ul>
  )
}
